









import { Component, Vue } from 'vue-property-decorator';
import Logo from '../../assets/logo.svg?inline';

@Component({
  components: {
    Logo,
  },
})
export default class Auth extends Vue {}
